var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "van-tabbar",
    {
      staticClass: "tabbar-wrap",
      attrs: { fixed: "" },
      on: { change: _vm.handleChange },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    _vm._l(_vm.data, function (item, index) {
      return _c("van-tabbar-item", {
        key: index,
        scopedSlots: _vm._u(
          [
            _vm.skinChange !== "newYear"
              ? {
                  key: "icon",
                  fn: function (props) {
                    return [
                      item.to.name !== "SearchPage"
                        ? _c("i", {
                            class: [
                              "iconfont",
                              _vm.handleSetTabBarIcon(item, index),
                            ],
                          })
                        : _c(
                            "div",
                            {
                              staticClass: "search-tabbar",
                              class: { active: props.active },
                            },
                            [
                              _c("i", {
                                staticClass: "iconfont icon-a-searchkuang",
                              }),
                            ]
                          ),
                      _c("p", [_vm._v(_vm._s(item.title))]),
                    ]
                  },
                }
              : {
                  key: "default",
                  fn: function (undefined) {
                    return [
                      _c("img", {
                        staticClass: "skinImg",
                        attrs: { src: item.skinImg },
                      }),
                      _c("span", [_vm._v(_vm._s(item.title || "搜索"))]),
                    ]
                  },
                },
          ],
          null,
          true
        ),
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }